import { yupResolver } from "@hookform/resolvers/yup";
import {
    Box,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    TextField,
} from "@mui/material";
import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";

import { Withdrawal } from "../../interfaces/withdrawal";
import { rejectWithdrawalSchema } from "../../validators/schemas/rejectWithdrawal";

interface WithdrawalRejectConfirmModalProps {
    onConfirm?: (data: Withdrawal) => void;
    onCancel?: () => void;
    open: boolean;
    data?: Withdrawal | null;
}

type FormData = {
    admin_note: string;
};

export function WithdrawalRejectConfirmModal({
    open,
    onCancel,
    onConfirm,
    data,
}: WithdrawalRejectConfirmModalProps) {
    const {
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm<FormData>({
        mode: "onChange",
        resolver: yupResolver(rejectWithdrawalSchema),
    });

    const handleClose = () => {
        onCancel?.();
        reset();
    };

    const onSubmit = (values: FormData) => {
        if (data) {
            onConfirm?.({ ...data, admin_note: values.admin_note || null });
        }

        handleClose();
    };

    useEffect(() => {
        if (data) {
            reset({ admin_note: data?.admin_note || "" });
        }

        return () => reset();
    }, [data]);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="sm"
            disableRestoreFocus
        >
            <DialogTitle variant="h6" component="h2">
                Recusar Saque
            </DialogTitle>

            <DialogContent>
                <Box gap={2} display="flex" flexDirection="column" pt={2}>
                    <Controller
                        name="admin_note"
                        control={control}
                        render={({ field }) => (
                            <TextField
                                label="Motivo da rejeição"
                                size="small"
                                fullWidth
                                multiline
                                rows={4}
                                placeholder="Descreva o motivo da rejeição (Opcional)"
                                error={!!errors.admin_note}
                                helperText={errors.admin_note?.message}
                                inputProps={{ maxLength: 255 }}
                                {...field}
                            />
                        )}
                    />
                </Box>

                <Box display="flex" justifyContent="flex-end" gap={1} mt={2}>
                    <Button onClick={handleClose} color="inherit">
                        Cancelar
                    </Button>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={handleSubmit(onSubmit)}
                    >
                        Confirmar Rejeição
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
}
